export default function ContentFourth({ verticalTabsState }) {
  return (
    <div
      className={`content-4 overflow-hidden max-h-0 transition-opacity duration-[0.2s] ease-linear ${
        verticalTabsState === 4
          ? "max-h-[1000px] opacity-100 z-2"
          : "opacity-0 max-h-0 z-0"
      }`}
    >
      <h1 className="text-[36px] leading-[40px] font-mont my-[0.67em]">
        <strong>Online Invoicing Made Easy</strong>
      </h1>

      <p className="my-[25px] text-[16px] leading-[28px]">
        Manage contracts, create recurring invoices,
        <br></br>
        bill timesheets, get paid faster.
      </p>

      <h2 className="font-mont text-[30px] leading-[40px] mt-5 mb-[10px]">
        <strong>Turn Quotes Into Invoices With Minimal Effort</strong>
      </h2>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Bill automatically based on sales orders, delivery orders, contracts, or
        time and material.
      </p>

      <h2 className="font-mont text-[30px] leading-[40px] mt-5 mb-[10px]">
        <strong>Get Paid Faster</strong>
      </h2>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Online payments and automated follow-ups.
      </p>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Accept online payments via Paypal, Ingenico, Buckaroo, Stripe,
        Authorize.net, Atos Worldline or Adyen. Eliminate the hassle of sending
        reminders for late or outstanding payments. Automated follow-ups are
        simple to configure and help to streamline billing to make payments
        quick and easy.
      </p>

      <h2 className="font-mont text-[30px] leading-[40px] mt-5 mb-[10px]">
        <strong>Simplify Your Accounting</strong>
      </h2>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Keep track of bank account movements and the status of invoices.
      </p>

      <h2 className="font-mont text-[30px] leading-[40px] mt-5 mb-[10px]">
        <strong>Analyze Your Sales</strong>
      </h2>

      <p className="my-[10px] text-[16px] leading-[20px]">
        Access insightful data to get the big picture.
      </p>
    </div>
  );
}
